type AdminBranchedEmployeeSelectionQuestionProps = {
	question: string;

	note: string;

	questions: AdminObservationQuestion[];

	goToValue: string;

	onGoToChange: (value: string) => void;
};

const AdminBranchedEmployeeSelectionQuestion = ({
	question,
	note,
	questions,
	goToValue,
	onGoToChange
}: AdminBranchedEmployeeSelectionQuestionProps) => {
	return (
		<div className="w-full pt-5 pr-6 pb-8 pl-6 rounded-lg bg-muted flex flex-col gap-6">
			<p className="text-base font-medium text-foreground">Employee selection</p>

			<div className="flex flex-col gap-4">
				<p className="text-xl font-medium">{question}</p>
				<p className="text-base font-normal">{note}</p>
			</div>

			<div>
				<div className="flex justify-between items-end mb-2">
					<label className="text-base font-medium">Go to</label>
					<span className="text-xs font-normal">Required</span>
				</div>

				<select
					className="w-full h-10 px-3 bg-white border border-border rounded"
					value={goToValue}
					onChange={(e) => onGoToChange(e.target.value)}
				>
					<option value="NEXT">Next</option>
					<option value="END_OF_FORM">End of the form</option>

					<optgroup label="Questions in the form">
						{questions.map((question) => (
							<option key={question.id} value={question.id ?? undefined}>
								&ldquo;{question.question}&rdquo;
							</option>
						))}
					</optgroup>
				</select>
			</div>
		</div>
	);
};

export default AdminBranchedEmployeeSelectionQuestion;
